import React, { useRef, useState, useEffect } from "react";
import { RCCAlert, RCCButton, RCCDropDownItem, RCCGrid, RCCHookToast, RCCIcon, RCCInput, RCCServicesApi, RCCTooltip, arrayMove } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { unstable_batchedUpdates as unstableBatchedUpdates } from "react-dom";
import SidebarCard from "src/components/SidebarCard";
import { useForm } from "react-hook-form";
import Title from "src/components/Title";
import LovUsers from "src/components/Lov/Users";
import FiltersContainer from "src/components/FiltersContainer";
import Select from "src/components/Select";
import DateTimePickerRange from "src/components/DateTimePickerRange";
import { standardErrorMessages } from "src/utils/errors";
import InfiniteScrollWithoutFetch from "src/components/InfiniteScrollWithoutFetch";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import ModalsSubactions, { IRefModalSubaction } from "src/pages/Actions/Panel/components/modalsSubactions";
import ModalCancel, { IActionCancelRef } from "src/pages/Actions/Panel/components/modalCancel";
import CommentsModal, { IActionCommentsRef } from "src/pages/Actions/Panel/components/modalComments";
import ModalHistory, { IActionHistoryRef } from "src/pages/Actions/Panel/components/modalHistory";
import ModalPostponement, { IActionPostponementRef } from "src/pages/Actions/Panel/components/modalPostponement";
import ModalProgress from "src/pages/Actions/Panel/components/modalProgress";
import ModalAddChangeDelete from "src/pages/Actions/Panel/components/modalAddChangeDelete";
import ModalEfficiency, { IActionEfficiencyRef } from "src/pages/Actions/Panel/components/modalEfficiency";
import ContainerWithoutContext from "src/components/Sortable/ContainerWithoutContext";
import { verticalListSortingStrategy } from "src/components/Sortable/Container/strategy";
import extractSingleValueFromArrayOfObject from "src/utils/extractSingleValueFromArrayOfObject";
import formatDate from "src/utils/formatDate";
import SortableContext from "src/components/Sortable/Context";
import SortableItem from "src/components/Sortable/Item";
import { useLocation, useParams } from "react-router-dom";
import getUrlSearchParams from "src/utils/getUrlSearchParams";
import { useConfirmModal } from "src/context/ConfirmModal/context";
import CheckPermission from "src/components/CheckPermission";
import { PermissionEnum } from "src/context/Auth/interface";
import { useAuth } from "src/context/Auth/context";
import DropdownWithBackground from "src/components/DropdownWithBackground";
import ModalShowPostponements from "src/pages/Actions/Panel/components/modalShowPostponements";
import { Card, SidebarBodyKanban, SidebarItem } from "./styles";
import { ColumnKanban, IAssociations, IFilters, IFiltersKanban, IKanban, IKanbanModels, IKanbanType,IRefKanbanModal, RowKanban } from "./interface";
import { ActionSituation, IActionShowPostponementRef, IRefActionsPanelModalAddChangeDelete, IRefActionsProgressModal } from "../../../Panel/interface";
import ModalAddOrChangeKanban from "./modals";
import DroppableContainer from "../../components/DroppableContainer";
import SimplifiedCard from "../../components/SimplifiedCard";
import BadgeKanbanType from "./components/badgeKanbanType";
import KanbanContent from "./components/kanbanContent";

interface IMultipleKanban {
	idKanban?: number
}


const MultipleKanban: React.FC<IMultipleKanban> = ({
	idKanban
}) => {


	const params = useParams<{
		kanbanId?: string;
	}>();

	const query = useLocation();
	const objQueryParams = getUrlSearchParams(query.search);

	const { translate } = useTranslation();

	type Items = Record<string, RowKanban[]>;
	type Columns = Record<string, ColumnKanban>;
	const [showFilters, setShowFilters] = useState(false);
	const { addToast } = RCCHookToast();
	const { confirm } = useConfirmModal();
	const { superUser, administrator, checkIfHasSpecificPermission } = useAuth();

	const ITEMS_WITH_NO_CONTAINER = "01-";
	const [waitingForResponse, setWaitingForResponse] = useState(false);
	const [items, setItems] = useState<Items>({});
	const [columns, setcolumns] = useState<Columns>({});
	const [errorAssociation, setErrorAssociation] = useState<{
		module: "AC" | "PR",
		code: string
	} | undefined>(undefined);

	const [filters, setFilters] = useState<IFilters>({ 
		late:  "",
		responsible: "",
		situation: [{
			label: translate("Concluída"),
			value: ActionSituation.FINISHED
		},{
			label: translate("Em andamento"),
			value: ActionSituation.IN_PROGRESS
		},{
			label: translate("Não Iniciada"),
			value: ActionSituation.NOT_STARTED
		}],
		startDate: null,
		endDate: null
	});

	const [filtersKanban, setFiltersKanban] = useState<IFiltersKanban>({ 
		active:  "S",
		filter: "",
		type: ""
	});

	const [associations, setAssociations] = useState<IAssociations | undefined>(undefined);

	const modalAddChangeDelete = useRef<IRefActionsPanelModalAddChangeDelete>(null);
	const refModalAddOrChange = useRef<IRefKanbanModal>(null);
	const modalsSubactionsRef = useRef<IRefModalSubaction>(null);
	const modalCommentsRef = useRef<IActionCommentsRef>(null);
	const modalProgressRef = useRef<IRefActionsProgressModal>(null);
	const modalHistoryRef = useRef<IActionHistoryRef>(null);
	const modalPostponementRef = useRef<IActionPostponementRef>(null);
	const modalCancelRef = useRef<IActionCancelRef>(null);
	const modalEfficiencyRef = useRef<IActionEfficiencyRef>(null);
	const modalShowPostponements = useRef<IActionShowPostponementRef>(null);
	const { setLoading } = useLoaderBackdrop();

	const { 
		handleSubmit : handleSubmitFilters, 
		control: controlFilters, 
		reset: resetFilters,
		setValue: setValueFilters
	} = useForm();

	const { 
		handleSubmit : handleSubmitFiltersKanban, 
		control: controlFiltersKanban, 
		register: registerFiltersKanban,
		reset: resetFiltersKanban
	} = useForm();
	
	const submitFiltersOfKanBan = (data: any) => {
		setSelectedKanban(null);
		setFiltersKanban({
			active: typeof data.active === "object" ? data.active.value : data.active,
			filter: data.filter,
			type: typeof data.type === "object" ? data.type.value : data.type
		});
	};

	const optionsActive = [{
		label: translate("Não"),
		value: "N"
	},
	{
		label: translate("Sim"),
		value: "S"
	},
	{
		label: translate("Todos"),
		value: "T"
	}];

	const [activeId, setActiveId] = useState<string | null>(null);

	const [cards, setCards] = useState<IKanban[]>([]);
	const [selectedKanban, setSelectedKanban] = useState<IKanban | null>(null);

	const TRASH_ID = "void";
	const PLACEHOLDER_ID = "placeholder";

	const recentlyMovedToNewContainer = useRef(false);	
	const [containers, setContainers] = useState(Object.keys(columns));

	const [sidebarModeKanban, setSidebarModeKanban] = useState(true);

	const findContainer = (idX: string) => {
		if (idX in items) {
			return idX;
		}
		return Object.keys(items).find((key) =>	items[key].map(({ id }) => id).find((key2) => key2.includes(idX)));
	};
	
	const getNextContainerId = (idColumn?: number) => {
		const containeIds = Object.keys(items);

		if(idColumn) 
			return `${idColumn}-${selectedKanban}`;

		return `${containeIds.length - 1}-${selectedKanban}`;
	};

	const handleAddColumn = async() => {
		const res = await queryAddColumn();

		if(!res)
			return;

		const newContainerId = getNextContainerId(res);
		unstableBatchedUpdates(() => {
			setContainers((containersX) => [...containersX, newContainerId]);
			setItems((itemsX) => ({
				...itemsX,
				[newContainerId]: []
			}));
			setcolumns((columnsX) => ({
				...columnsX,
				[newContainerId]: {
					kba002Id: res,
					kba002Kba001Id: selectedKanban,
					kba002Cor: "#d3d3d3",
					kba002Descricao: "Nova coluna",
					kba002Ordem: 0
				}
			}));
		});
	};

	const submitFilters = (data: any) => {
		setFilters({
			late: data.late,
			responsible: data.responsible,
			situation: data.situation,
			endDate: data.endDate,
			startDate: data.startDate
		});
	};

	const onClickCardFuncion = async (kanban: IKanban, associationsX?: IAssociations) => {
		setSelectedKanban(kanban);
		await queryColumnsKanban(kanban, associationsX);
		setSidebarModeKanban(false);
	};

	const onRemoveColumn = async (containerID: string) => {
		await queryRemoveColumn(columns[containerID].kba002Id, columns[containerID].kba002Descricao, containerID, containers);
	};
	
	const onCallbackAdd = (id: number) => {
		queryKanbans(id);
	};

	const onCallbackDelete = (id: number) => {
		setCards((prevState) => prevState.filter((card) => card.kba001Id !== id));

		if(selectedKanban?.kba001Id === id){
			setSelectedKanban(null);
			setContainers([]);
			setcolumns({});
			setItems({});
			setActiveId(null);
		}
	};

	const onCallbackDeleteAction = (idNumber: number) => {
		const id = idNumber.toString();

		const actualContaiener = findContainer(id);
		if(!actualContaiener)
			return;


		const objects = items[actualContaiener].filter((item: any) => item.inb001Id !== idNumber);

		setItems((itemsX) => ({
			...itemsX,
			[actualContaiener]: objects
		}));
	};

	const onCallbackChange = () => {
		queryKanbans();
	};

	const queryKanbans = async (id?: number, associationsX?: IAssociations) => {
		setLoading(true);
		try{
			const { data } = await RCCServicesApi.getRequest({
				method: "Kanban/List",
				urlParameters: {
					...filtersKanban,
					type: filtersKanban.type ? Number(filtersKanban.type) : ""
				}
			});

			const kanbansData = data as IKanban[];

			setCards(kanbansData);
			setLoading(false);

			if(id){
				const wasFound = kanbansData.map(({ kba001Id }) => kba001Id).findIndex((idX) => idX === id);
				if(wasFound !== -1)
					onClickCardFuncion(kanbansData[wasFound], associationsX);
			}

		}catch(err){
			setLoading(false);
			standardErrorMessages(err, translate("Erro carregar kanbans"), addToast);
		}
	};

	const queryRemoveColumn = async(id: number, title: string, containerID: string, originalContainers: string[]) => {
		await confirm(
			translate("Exclusão de coluna"), 
			`${translate("Deseja realmente excluir a coluna")}: ${title} ?`,
			async () => {
				setWaitingForResponse(true);
				await RCCServicesApi.deleteRequest({
					method: "Kanban/DeleteColumn",
					urlParameters: {
						id
					}
				});
				addToast({
					color: "green",
					description: translate("Coluna excluída com sucesso"),
					title: translate("Sucesso")
				});
				setWaitingForResponse(false);		
				setContainers((containersX) =>
					containersX.filter((idX) => idX !== containerID)
				);
			},
			(err) => {
				setWaitingForResponse(false);
				setContainers(originalContainers);
				const textMessageError = err?.response?.data?.Message;
				if(textMessageError === "hasAssocietedActions"){
					addToast({
						title: translate("Erro"),
						description: translate("Esta coluna possui ações vinculadas"),
						color: "yellow"
					});
					return;
				}
				standardErrorMessages(err, translate("Erro ao remover coluna"), addToast);
			},
			true
		);
	};

	const queryAddColumn = async() => {
		try{
			const { data } = await RCCServicesApi.postRequest({
				method: "Kanban/InsertColumn",
				body: {
					kba002Kba001Id: selectedKanban?.kba001Id, 
					kba002Descricao: "Nova coluna", 
					kba002Cor: "86E2D5"
				}
			});
			
			return data;
		}catch(err){
			standardErrorMessages(err, translate("Erro ao inserir coluna"), addToast);
			
			return false;
		}
	};

	const objToString = (obj: any) => {
		if(typeof obj === "object")
			return obj.value;
		if(typeof obj === "number")
			return obj.toString();
		if(typeof obj !== "string")
			return "";
		return obj;
	};

	const queryColumnsKanban = async (kanban: IKanban, associationsX: IAssociations | undefined) => {
		setLoading(true);
		try{
			setWaitingForResponse(true);
			const { data } = await RCCServicesApi.getRequest({
				method: "Kanban/KanbanData",
				urlParameters: {
					idKanban: kanban.kba001Id,
					late: filters.late && objToString(filters.late) !== "T" ?  objToString(filters.late) :  "",
					responsible: filters.responsible && objToString(filters.responsible) ? objToString(filters.responsible) : "",
					situation: filters.situation && filters.situation.length > 0 ?  extractSingleValueFromArrayOfObject("value", filters.situation) : "",
					startDate: filters.startDate ? formatDate(filters.startDate) : "",
					endDate: filters.endDate ? formatDate(filters.endDate) : "",
					associationId:  associationsX && associationsX?.associationId ? associationsX.associationId : "",
					associationId2: associationsX &&  associationsX?.associationId2 ? associationsX?.associationId2 : ""
				}
			});
			setSelectedKanban((prevState) => {
				if(!prevState)
					return prevState;
				return {
					...prevState,
					associateType: data.levelUsedAssociations
				};
			});
			setItems(data.dataColumns);
			setContainers(Object.keys(data.dictionaryColumns));
			setcolumns(data.dictionaryColumns);
			setLoading(false);
			setErrorAssociation(undefined);
			setWaitingForResponse(false);
		}catch(err: any){
			setLoading(false);
			setWaitingForResponse(true);
			setContainers([]);
			setcolumns({});
			setItems({});

			const messageError = err?.response?.data?.Message;
			if(messageError){
				const moduleAndCode = messageError.split("-");
				setErrorAssociation({
					module: moduleAndCode[0],
					code: moduleAndCode[1]
				});

				if(moduleAndCode[1] === "2"){
					setSelectedKanban((prevState) => {
						if(!prevState)
							return prevState;
						return {
							...prevState,
							associateType: 2
						};
					});
				}
				return; 
			}
			standardErrorMessages(err, translate("Erro ao carregar colunas"), addToast);
		}
	};

	const queryOrderColumns = async (rows: string[]) => {
		const rowsOrdered: any[] = [];
		rows.forEach((item: any, index) => {
			const row = {
				kba002Id: parseInt(item, 10),
				Kba002Kba001Id: selectedKanban?.kba001Id,
				kba002Ordem: index + 1
			};
			rowsOrdered.push(row);
		});
		setWaitingForResponse(true);
		try{
			await RCCServicesApi.putRequest({
				method: "Kanban/UpdateOrderColumns",
				body: {
					columns: rowsOrdered
				}
			});
			setWaitingForResponse(false);
			return true;
		}catch(err){
			standardErrorMessages(err, translate("Erro ao atualizar coluna"), addToast);
			setWaitingForResponse(false);
			return false;
		}
	};

	const queryOrderRows = async (rows: RowKanban[] | any[], column: string) => {
		const rowsOrdered: any[] = [];

		rows.forEach((item: RowKanban, index) => {
			const row = {
				Inb001Id: item.inb001Id,
				Kba002Id: parseInt(column, 10),
				Inb017Ordem: index + 1
			};
			rowsOrdered.push(row);
		});
		setWaitingForResponse(true);
		try{
			await RCCServicesApi.putRequest({
				method: "Kanban/UpdateOrderRows",
				body: {
					rows: rowsOrdered
				}
			});
			setWaitingForResponse(false);
			return true;
		}catch(err){
			standardErrorMessages(err, translate("Erro ao atualizar ação"), addToast);
			setWaitingForResponse(false);
			return false;
		}

	};

	const queryRemoveRow = async (id: string) => {
		setWaitingForResponse(true);
		try{
			await RCCServicesApi.deleteRequest({
				method: "Kanban/RemoveRowOfKankban",
				urlParameters: {
					id
				}
			});
			setWaitingForResponse(false);
			return true;
		}catch(err){
			standardErrorMessages(err, translate("Erro ao atualizar ação"), addToast);
			setWaitingForResponse(false);
			return false;
		}
	};

	const callbackUpdateAction = async (id: string) => {
		try{
			const response = await RCCServicesApi.getRequest({
				method: "Actions/InfosOfActionForList",
				urlParameters: {
					id
				}
			});
			const action = response.data as RowKanban;

			const actualContaiener = findContainer(id);
			if(!actualContaiener)
				return;

			const actualItem = items[actualContaiener].findIndex((item: any) => item.inb001Id === id);
			if(actualItem === -1)
				return;

			const objects = [...items[actualContaiener]];

			objects[actualItem] = {...action, id : action.inb001Id.toString() };

			setItems((itemsX) => ({
				...itemsX,
				[actualContaiener]: objects
			}));

		}catch(err){
			standardErrorMessages(err, translate("Erro ao atualizar ação, favor atualizar a pagina"), addToast);
		}
	};

	const handleDragStart = (activeIdX: string) => {
		setActiveId(activeIdX);
	};				

	const handleDragOver = (activeIdX: string, overId: string) => {
		if (!overId || overId === TRASH_ID || activeIdX in items) {
			return;
		}

		const overContainer = findContainer(overId);
		const activeContainer = findContainer(activeIdX);

		if (!overContainer || !activeContainer) {
			return;
		}

		if (activeContainer !== overContainer) {
			setItems((itemsX) => {
				const activeItems = itemsX[activeContainer];
				const overItems = itemsX[overContainer];
				const overIndex = overItems.map(({ id }) => id).indexOf(overId);
				const activeIndex = activeItems.map(({ id }) => id).indexOf(activeIdX);

				let newIndex: number;

				if (overId in items) {
				 	newIndex = overItems.length + 1;
				}else{
					newIndex = overIndex >= 0 ? overIndex : overItems.length + 1;
				}

				recentlyMovedToNewContainer.current = true;

				return {
					...itemsX,
					[activeContainer]: itemsX[activeContainer].filter(
						(item) => String(item.id) !== activeIdX
					),
					[overContainer]: [
						...itemsX[overContainer].slice(0, newIndex),
						itemsX[activeContainer][activeIndex],
						...itemsX[overContainer].slice(
							newIndex,
							itemsX[overContainer].length
						)
					]
				};
			});
		}
	};

	const handleDragEnd = async (activeIdX: string, overId: string) => {
		if(activeIdX in items){
			if (overId) {

				const originalColumns = containers;

				const activeIndex = containers.indexOf(activeIdX);
				const overIndex = containers.indexOf(overId);

				const orderedContainers = arrayMove(containers, activeIndex, overIndex);
				setContainers(orderedContainers);

				const res = await queryOrderColumns(orderedContainers);
				if(!res){
					setContainers(originalColumns);
				}
			}
			return;
		}
		
		const activeContainer = findContainer(activeIdX);

		if (!activeContainer) {
			setActiveId(null);
			return;
		}

		if (!overId) {
			setActiveId(null);
			return;
		}

		if (overId === PLACEHOLDER_ID) {
			
			const res = await queryAddColumn();
			if(!res)
				return;

			const newContainerId = getNextContainerId(res);


			if(activeIdX)
				queryOrderRows([{
					inb001Id: parseInt(activeIdX, 10),  
					id: activeIdX,
					inb001PercConclusao: 0,
					inb001Titulo: "-"
				}], newContainerId.split("-")[0]);

			unstableBatchedUpdates(() => {
				setContainers((containersX) => [...containersX, newContainerId]);
				setItems((itemsX) => ({
					...itemsX,
					[activeContainer]: itemsX[activeContainer].filter(
						(id) => String(id.id) !== activeIdX
					),
					[newContainerId]: itemsX[activeContainer].filter(
						(id) => String(id.id) === activeIdX
					)
				}));
				setcolumns((columnsX) => ({
					...columnsX,
					[newContainerId]: {
						kba002Id: 0,
						kba002Cor: "#d3d3d3",
						kba002Descricao: "Nova coluna",
						kba002Ordem: 0
					}
				}));
				setActiveId(null);
			});
			return;
		}

		const overContainer = findContainer(overId);

		if (overContainer) {
			const activeIndex = items[activeContainer].map(({ id }) => id).indexOf(activeIdX);
			const overIndex = items[overContainer].map(({ id }) => id).indexOf(overId);

			const activeContainerNumber =  activeContainer.split("-")[0];

			if(activeContainerNumber === "01"){
				const res = await queryRemoveRow(activeIdX);
				if(!res) return;
			}else {
				const ordenedData = arrayMove(items[overContainer], activeIndex, overIndex);

				const originalItems = items;

				setItems((itemsX) => ({
					...itemsX,
					[overContainer]: arrayMove(
						itemsX[overContainer],
						activeIndex,
						overIndex
					)
				}));

				const res = await queryOrderRows(ordenedData, activeContainerNumber);
				if(!res){
					setItems(originalItems);
				}
			
			}

		}
		setActiveId(null);
	};

	const sidebarExchangeFunction = () => {
		setSidebarModeKanban((prevState) => !prevState);
	};

	useEffect(() => {
		if(selectedKanban)
			queryColumnsKanban(selectedKanban, associations);
	}, [filters]);

	useEffect(() => {
		const associationsY = {
			associationId: objQueryParams?.associationId ? parseInt(objQueryParams?.associationId, 10) : 0,
			associationId2: objQueryParams?.associationId2 ? parseInt(objQueryParams?.associationId2, 10) : 0
		};
		setAssociations(associationsY);
		const initialKanban = params?.kanbanId ? parseInt(params?.kanbanId,10) : idKanban;
		queryKanbans(initialKanban, associationsY);
	}, [filtersKanban]);

	const checkTypeKanban = (kanban: IKanban) => {
		if(kanban.kba001Tipo === IKanbanType.ACTIONS)
			return IKanbanModels.ACTIONS;
		if(kanban.kba001Tipo === IKanbanType.PROJECT && kanban.associateType === 2)
			return IKanbanModels.PROJECT_AGILE;
		if(kanban.kba001Tipo === IKanbanType.PROJECT)
			return IKanbanModels.PROJECT;
		return IKanbanModels.ACTIONS;
	};

	const CustomCards = <SidebarItem>
		{sidebarModeKanban ? (<>
			{cards && (
				<>
					{cards.length <= 0 ? (
						<RCCAlert
							description={translate("Não foram encontrados dados")} />
					) : (
						<>
							{cards.map((card: IKanban) => <Card
								key={card.kba001Id}
								selected={card.kba001Id === selectedKanban?.kba001Id}
								color={card.kba001Ativo === "S" ? "var(--green)" : "var(--red)"}
							>
								<div className="card-head">
									<span className="icon-options">
										<DropdownWithBackground
											position="leftEnd"
											callerComponent={
												<RCCButton
													color="transparent"
												>
													<RCCIcon name="dotsVertical" size={18} color={card.kba001Id === selectedKanban?.kba001Id ? "#FFF" : "var(--grey)"}/>
												</RCCButton>
											}	
										>
											<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE}>
												{(superUser || administrator || card.permission >= 2) && (
													<RCCDropDownItem
														selfEnclose
														onClick={() => refModalAddOrChange.current?.actionButtonChange(card.kba001Id)}
													>
														<RCCIcon name="pencil" />
														{translate("Alterar")}
													</RCCDropDownItem>
												)}
											</CheckPermission>
											<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE_DELETE}>
												{(superUser || administrator || card.permission >= 2) && (
													<RCCDropDownItem
														selfEnclose
														onClick={() => refModalAddOrChange.current?.actionButtonDelete(card.kba001Id, card.kba001Descricao)}
													>
														<RCCIcon name="trash" />
														{translate("Excluir")}
													</RCCDropDownItem>
												)}
											</CheckPermission>
										</DropdownWithBackground>
									</span>
								</div>
								<SidebarBodyKanban onClick={(e) => { e.stopPropagation(); onClickCardFuncion(card, undefined); } }>
									<div className="card-body">
										<span title={card.kba001Descricao}>{card.kba001Descricao}</span>
										<BadgeKanbanType
											type={card.kba001Tipo} />
									</div>
								</SidebarBodyKanban>
							</Card>
							)}
						</>
					)}
				</>)}
		</>) : (
			<>
				<Title color="purple" size="md">
					{translate("Ações disponíveis")}
				</Title>
				<DroppableContainer
					key={ITEMS_WITH_NO_CONTAINER}
					idColumn={ITEMS_WITH_NO_CONTAINER}
					columnsData={columns[ITEMS_WITH_NO_CONTAINER]}
					onChangeColorColumn={undefined}
					onChangeTitleColumn={undefined}
					onRemove={onRemoveColumn}
					noStyle
				>
					<ContainerWithoutContext items={items[ITEMS_WITH_NO_CONTAINER] ?? []} strategy={verticalListSortingStrategy}>
						{!items[ITEMS_WITH_NO_CONTAINER] || items[ITEMS_WITH_NO_CONTAINER].length === 0 ? (
							<Title color="grey" size="xs" styleInline="justify-content: center;">
								{translate("Nenhuma ação disponível")}
							</Title>
						) : (

							<InfiniteScrollWithoutFetch
								defaultNumberOfElements={15}
								manuallyToggleShowMore
								listElements={items[ITEMS_WITH_NO_CONTAINER] ?? []}
								mapper={(valueItem) => (
									<React.Fragment key={valueItem.id}>
										{valueItem && valueItem.id && (
											<SortableItem
												id={valueItem.id}
												disabled={!(superUser || administrator || (selectedKanban? selectedKanban.permission >= 2 : false) && checkIfHasSpecificPermission("actions/kanban", PermissionEnum.CREATE_UPDATE))}
											>
												<SimplifiedCard
													value={valueItem}
													modalsRef={modalAddChangeDelete}
													modalProgressRef={modalProgressRef}
													modalCancelRef={modalCancelRef}
													modalPostponementRef={modalPostponementRef}
													onCallbackUpdateFunction={callbackUpdateAction} 
													disabled={!(superUser || administrator || (selectedKanban? selectedKanban.permission >= 2 : false) && checkIfHasSpecificPermission("actions/kanban", PermissionEnum.CREATE_UPDATE))}
												/>
											</SortableItem>
										)}
									</React.Fragment>
								)} />
		
						)}
					</ContainerWithoutContext>
				</DroppableContainer>
			</>
		)}
	</SidebarItem>;
	
	return (
		<>
		
			<SortableContext 
				onDragStart={handleDragStart}
				onDragOver={handleDragOver}
				onDragEnd={handleDragEnd}
				executeOnDragEndWhenActiveAndOverEquals
			>
				<SidebarCard 
					buttonsContent={
						<>
							<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE} >
								<RCCTooltip
									text={translate("Adicionar kanban")}
									color="purple"
								>
									<RCCButton
										icon={{name: "plus", color: "#FFF", size: 16}}
										color="purple"
										layout="isRounded"
										size="md"
										onClick={() => refModalAddOrChange.current?.actionButtonAdd(onCallbackAdd)}
									/>
								</RCCTooltip>
							</CheckPermission>
							<RCCTooltip
								text={sidebarModeKanban ? translate("Exibir ações") : translate("Exibir kanbans")}
								color="grey"
							>
								<RCCButton
									icon={{name: sidebarModeKanban ?  "list" : "kanban", color: "#FFF", size: 16}}
									color="grey"
									layout="isRounded"
									disabled={!selectedKanban}
									size="md"
									onClick={sidebarExchangeFunction}
								/>
							</RCCTooltip>
							<RCCTooltip
								text={translate("Filtros")}
								color={showFilters ? "blue" : "grey"}
							>
								<RCCButton
									icon={{name: "filter", color: "#FFF", size: 16}}
									color={showFilters  ? "blue" : "grey"}
									layout="isRounded"
									size="md"
									onClick={() => setShowFilters((prevState) => !prevState)}
								/>
							</RCCTooltip>
						</>
					}
					filterContent={
						<>
							{sidebarModeKanban ? (
								<FiltersContainer
									onSubmitFilters={handleSubmitFiltersKanban(submitFiltersOfKanBan)}
									resetFilters={() => resetFiltersKanban({ 
										active: { value: "S", label: translate("Sim") },
										filter: "",
										type: { value: "", label:"" }
									})}
									showFilters={showFilters}
								>
									<RCCGrid
										container 
										item
										xs={12}
									>
										<Select 
											control={controlFiltersKanban}
											name="active"
											label={translate("Ativo")}
											options={optionsActive}
											defaultValue={optionsActive.find((x) => x.value === filtersKanban.active)}
											submit="value and label"
										/>
									</RCCGrid>
									<RCCGrid
										container 
										item
										xs={12}
									>
										<Select 
											control={controlFiltersKanban}
											name="type"
											label={translate("Tipo")}
											options={[{
												label: translate("Ações"),
												value: IKanbanType.ACTIONS.toString()
											},
											{
												label: translate("Projetos"),
												value:  IKanbanType.PROJECT.toString()
											}]}
											defaultValue={undefined}
											submit="value and label"
										/>
									</RCCGrid>
									<RCCGrid
										container 
										item
										xs={12}
									>
										<RCCInput 
											register={registerFiltersKanban}
											name="filter"
											label={translate("Pesquisar")}
											defaultValue={filtersKanban.filter}
										/>
									</RCCGrid>
								</FiltersContainer>
							) :(
								<FiltersContainer
									onSubmitFilters={handleSubmitFilters(submitFilters)}
									resetFilters={() => resetFilters({ 
										responsible: { value: "", label: ""},
										late: { value: "T", label: translate("Todos") },
										situation: [{
											label: translate("Concluída"),
											value: ActionSituation.FINISHED
										},{
											label: translate("Em andamento"),
											value: ActionSituation.IN_PROGRESS
										},{
											label: translate("Não Iniciada"),
											value: ActionSituation.NOT_STARTED
										}],
										startDate: null,
										endDate: null
									})}
									showFilters={showFilters}
								>
									<RCCGrid
										container
										item
									>
										<RCCGrid
											container 
											item
											xs={12}
										>
											<LovUsers 
												control={controlFilters}
												name="responsible"
												label={translate("Responsável")}
												defaultValue={filters.responsible}
												isClearable
											/>
										</RCCGrid>
										<RCCGrid
											container 
											item
											xs={12}
										>
											<Select 
												control={controlFilters}
												name="late"
												label={translate("Atrasado")}
												options={[{
													label: translate("Não"),
													value: "1"
												},
												{
													label: translate("Sim"),
													value: "0"
												},
												{
													label: translate("Todos"),
													value: "T"
												}]}
												defaultValue={filters.late ? filters.late : { value: "T", label: translate("Todos") }}
												submit="value and label"
											/>
										</RCCGrid>
	
										<RCCGrid
											container 
											item
											xs={12}
										>
											<Select 
												control={controlFilters}
												name="situation"
												label={translate("Situação")}
												defaultValue={filters.situation || [{
													label: translate("Concluída"),
													value: ActionSituation.FINISHED
												},{
													label: translate("Em andamento"),
													value: ActionSituation.IN_PROGRESS
												},{
													label: translate("Não Iniciada"),
													value: ActionSituation.NOT_STARTED
												}]}
												options={[{
													label: translate("Cancelada"),
													value: ActionSituation.CANCELED
												},{
													label: translate("Em Rascunho"),
													value: ActionSituation.DRAFT
												},{
													label: translate("Concluída"),
													value: ActionSituation.FINISHED
												},{
													label: translate("Em andamento"),
													value: ActionSituation.IN_PROGRESS
												},{
													label: translate("Não Iniciada"),
													value: ActionSituation.NOT_STARTED
												}]}
												isMulti
											/>
										</RCCGrid>
	
										<DateTimePickerRange 
											type="datePicker"
											label={translate("Período")}
											labelSeparator={translate("até")}
											nameInit="startDate"
											nameEnd="endDate"
											control={controlFilters}
											defaultValueEnd={filters.endDate}
											defaultValueInit={filters.startDate}
											setValue={setValueFilters}
										/>
	
									</RCCGrid>
								</FiltersContainer>
							)}
						</>}
					customCards={CustomCards}
					content={
						selectedKanban ? <>
							<KanbanContent 
								 	 selectedKanban={selectedKanban}
								 	 typeKanban={checkTypeKanban(selectedKanban)}
									 columns={columns}
									 containers={containers}
									 findContainer={findContainer}
									 waitingForResponse={waitingForResponse}
									 items={items}								
									 onRemoveColumn={onRemoveColumn}
									 handleAddColumn={handleAddColumn}
									 activeId={activeId}
									 setcolumns={setcolumns}
									 modalCancelRef={modalCancelRef}
									 modalCommentsRef={modalCommentsRef}
									 modalEfficiencyRef={modalEfficiencyRef}
									 modalShowPostponementsRef={modalShowPostponements}
									 modalHistoryRef={modalHistoryRef}
									 modalPostponementRef={modalPostponementRef}
									 modalProgressRef={modalProgressRef}
									 modalAddChangeDelete={modalAddChangeDelete}
									 modalsSubactionsRef={modalsSubactionsRef}
									 callbackUpdateAction={callbackUpdateAction}
									 ITEMS_WITH_NO_CONTAINER={ITEMS_WITH_NO_CONTAINER}
									 PLACEHOLDER_ID={PLACEHOLDER_ID}
									 associations={associations}
									 errorAssociation={errorAssociation}
									 queryColumnsKanban={queryColumnsKanban}
							/>
						</> : null}
				/>
			</SortableContext>
				
			<ModalAddOrChangeKanban 
				ref={refModalAddOrChange} 
				onCallbackDelete={onCallbackDelete} 
				onCallbackChange={onCallbackChange}
			/>
				
			<ModalsSubactions
				ref={modalsSubactionsRef} 
				onCallbackClose={() => {}}
			/>

			<ModalAddChangeDelete 
				ref={modalAddChangeDelete} 
				onCallbackDelete={onCallbackDeleteAction}
			/>

			<CommentsModal ref={modalCommentsRef} />

			<ModalHistory ref={modalHistoryRef} />

			<ModalProgress ref={modalProgressRef} />

			<ModalPostponement ref={modalPostponementRef} />

			<ModalCancel ref={modalCancelRef} />

			<ModalEfficiency ref={modalEfficiencyRef} />

			<ModalShowPostponements ref={modalShowPostponements} />

		</>
	);
};

export default MultipleKanban;
